const Layout = () => import(/* webpackChunkName: "mcaudience" */ './Layout.vue');
const Tags = () => import(/* webpackChunkName: "mcaudience" */ './Tags.vue');
const Content = () => import(/* webpackChunkName: "mcaudience" */ './Content.vue');
const Channel = () => import(/* webpackChunkName: "mcaudience" */ './Channel.vue');
const Instructions = () => import(/* webpackChunkName: "mcaudience" */ './Instructions.vue');

export const routes = [
{
  path: 'mcaudience',
  redirect: {name: 'mcaudience.tags'},
  name: 'mcaudience',
  //empty component just for base
  component: Layout,
  meta: {
    title: 'McAudience',
    root: true,
  },
  children: [
    {
      path: 'tags',
      name: 'mcaudience.tags',
      component: Tags,
      meta: {
        menu: false,
      },
    },
    {
      path: 'content',
      name: 'mcaudience.content',
      component: Content,
      meta: {
        menu: false,
      },
    },
    {
      path: 'channel',
      name: 'mcaudience.channel',
      component: Channel,
      meta: {
        menu: false,
      },
    },
    {
      path: ':channel',
      name: 'mcaudience.instructions',
      component: Instructions,
      props: true,
      meta: {
        menu: false,
      },
    },
    
  ],
}
];

// TRANSLATIONS
import en from './i18n/en'
import i18n from '@/providers/i18n'

for (let [lang, bundle] of Object.entries({en})) {
  i18n.i18next.addResourceBundle(lang, 'mcaudience', bundle);
}

export function guard(router) {
  router.afterEach((to, from) => {
    if (to.name && to.name.split('.')[0] === 'mcaudience') {
      import(/* webpackChunkName: "mcaudience" */ './scss/style.scss');
    }
  });
}


// WEBPACK FOOTER //
// ./src/apps/mcaudience/index.js